import React, { useEffect, useRef } from "react"
import types from "prop-types"
import { redirectTo, answerOptionsListPath, ADMIN_GENERAL_SETTINGS_PATH } from "utils/routeHelpers"
import { GENERAL_SETTINGS_ANSWER_OPTIONS_TAB_SLUG } from "utils/tabSlugHelpers"
import AnswerOptionsListForm from "../AnswerOptionsListForm"

const goToAnswerOptionsTab = () => redirectTo(ADMIN_GENERAL_SETTINGS_PATH, { tab: GENERAL_SETTINGS_ANSWER_OPTIONS_TAB_SLUG })

const EditAnswerOptionsList = ({
  id, initialName = "", initialOptions = [], listNames,
}) => {
  const nameInputRef = useRef()

  useEffect(() => {
    nameInputRef.current?.focus()
  }, [])

  return (
    <div className="base-form">
      <AnswerOptionsListForm
        action={answerOptionsListPath(id)}
        edit
        initialName={initialName || ""}
        initialOptions={initialOptions || []}
        listNames={listNames}
        onCancel={goToAnswerOptionsTab}
        ref={nameInputRef}
      />
    </div>
  )
}

EditAnswerOptionsList.propTypes = {
  id: types.oneOfType([types.number, types.string]).isRequired,
  initialName: types.string,
  initialOptions: types.arrayOf(types.string),
  listNames: types.arrayOf(types.string).isRequired,
}

export default EditAnswerOptionsList
